var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlaystore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 408 466.9",
    width: "1em",
    height: "1em"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-playstore_svg__a",
    gradientUnits: "userSpaceOnUse",
    y1: 112.094,
    x2: 261.746,
    y2: 112.094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63be6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#5bbc6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab96a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.7 142.3L15 1.3C11.9-.5 8-.4 5 1.4c-3.1 1.8-5 5-5 8.6 0 0 .1 13 .2 34.4l179.7 179.7 81.8-81.8z",
    fill: "url(#google-playstore_svg__a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-playstore_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 0.152,
    y1: 223.393,
    x2: 179.896,
    y2: 223.393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ec6f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45afe3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.2 44.4C.5 121.6 1.4 309 1.8 402.3L180 224.1.2 44.4z",
    fill: "url(#google-playstore_svg__b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-playstore_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 179.896,
    y1: 229.464,
    x2: 407.976,
    y2: 229.464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa51a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#fab716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fac412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac80f"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.9 223l-141.2-80.7-81.9 81.8 92.4 92.4L403 240.3c3.1-1.8 5-5.1 5-8.6 0-3.6-2-6.9-5.1-8.7z",
    fill: "url(#google-playstore_svg__c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-playstore_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 1.744,
    y1: 345.521,
    x2: 272.296,
    y2: 345.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec3b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7515b"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 402.3c.2 33.3.3 54.6.3 54.6 0 3.6 1.9 6.9 5 8.6 3.1 1.8 6.9 1.8 10 0l255.3-148.9-92.4-92.4L1.7 402.3z",
    fill: "url(#google-playstore_svg__d)"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgGooglePlaystore as ReactComponent };